<!-- FAB circulaire en bas-centre (le bas-droite est occupé par le chat Brevo) -->
<button type="button" class="admin-fab" (click)="toggle()" title="Audit des traductions">
  <i class="fa-solid fa-language"></i>
  <span class="admin-fab-badge" *ngIf="(tracker.keys$ | async)?.length as n">{{ n }}</span>
</button>

<!-- Modal plein écran -->
<div class="admin-modal-backdrop" *ngIf="isOpen" (click)="close()"></div>
<div class="admin-modal" *ngIf="isOpen">

  <!-- ── Header ─────────────────────────────────────────────────────────────── -->
  <div class="admin-modal-header">
    <div class="title">
      <i class="fa-solid fa-language"></i>
      <h3 translate>Audit traductions</h3>
      <code class="route">{{ router.url }}</code>
    </div>
    <div class="stats">
      <span class="pill pill-success">{{ keys.length }} clés UI</span>
      <span class="pill pill-info" *ngIf="overrideCount > 0">{{ overrideCount }} overrides</span>
      <span class="pill pill-game" *ngIf="context">{{ context.items[0]?.name }}</span>
    </div>
    <button type="button" class="btn-close" (click)="close()" title="Fermer">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <!-- ── Tabs ───────────────────────────────────────────────────────────────── -->
  <div class="admin-tabs" *ngIf="context">
    <button type="button" class="admin-tab" [class.active]="activeTab === 'i18n'" (click)="switchTab('i18n')">
      <i class="fa-solid fa-file-code"></i>
      Traductions UI
    </button>
    <button type="button" class="admin-tab" [class.active]="activeTab === 'content'" (click)="switchTab('content')">
      <i class="fa-solid fa-pen-to-square"></i>
      {{ contentTabLabel }}
    </button>
  </div>

  <!-- ── Body ───────────────────────────────────────────────────────────────── -->
  <div class="admin-modal-body">

    <!-- ── Tab : Traductions UI ──────────────────────────────────────────────── -->
    <ng-container *ngIf="activeTab === 'i18n'">
      <div class="filter-bar">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input type="text" [(ngModel)]="search" [placeholder]="'Rechercher une clé…' | translate" class="search-input">
      </div>

      <div class="loading" *ngIf="loading">
        <i class="fa-solid fa-spinner fa-spin"></i> Chargement…
      </div>

      <div class="table-wrap" *ngIf="!loading">
        <table class="overrides-table">
          <thead>
            <tr>
              <th class="col-code" translate>Clé source</th>
              <th *ngFor="let lang of langSrcs" class="col-lang">{{ lang.shortCode | uppercase }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let key of filteredKeys; trackBy: trackByKey">
              <td class="col-code" [title]="key">
                <code>{{ key }}</code>
              </td>
              <td *ngFor="let lang of langSrcs" class="col-cell"
                  [class.has-override]="hasOverride(key, lang.shortCode)"
                  [class.cell-saving]="cellState[key]?.[lang.shortCode] === 'saving'"
                  [class.cell-saved]="cellState[key]?.[lang.shortCode] === 'saved'"
                  [class.cell-error]="cellState[key]?.[lang.shortCode] === 'error'">
                <textarea
                  #ta
                  [(ngModel)]="values[key][lang.shortCode]"
                  (input)="autoGrow(ta)"
                  (focus)="autoGrow(ta)"
                  (blur)="onCellBlur(key, lang.shortCode, ta)"
                  rows="1"
                  class="cell-input"
                  spellcheck="false"></textarea>
                <span class="cell-indicator" aria-hidden="true"></span>
                <button type="button"
                        *ngIf="hasOverride(key, lang.shortCode) && cellState[key]?.[lang.shortCode] !== 'saving'"
                        class="btn-delete-cell"
                        (click)="deleteCell(key, lang.shortCode)"
                        title="Supprimer l'override (revenir au JSON)">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="filteredKeys.length === 0">
              <td [attr.colspan]="langSrcs.length + 1" class="empty-row">
                Aucune clé trouvée.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!-- ── Tab : Contenu (toutes entités) ───────────────────────────────────── -->
    <ng-container *ngIf="activeTab === 'content' && context && currentConfig">

      <!-- Header avec nom de l'item (single) -->
      <div class="content-header" *ngIf="!currentConfig.multiItem">
        <div class="content-game-info">
          <i class="fa-solid fa-gamepad" *ngIf="context.type === 'game'"></i>
          <i class="fa-solid fa-layer-group" *ngIf="context.type === 'section'"></i>
          <span class="content-game-name">{{ context.items[0]?.name }}</span>
          <code class="content-game-id">id : {{ context.items[0]?.id }}</code>
        </div>
        <button type="button" class="btn-reload" (click)="loadContentData()" title="Recharger depuis l'API">
          <i class="fa-solid fa-rotate"></i>
        </button>
      </div>

      <div class="loading" *ngIf="contentLoading">
        <i class="fa-solid fa-spinner fa-spin"></i> Chargement…
      </div>

      <div class="table-wrap" *ngIf="!contentLoading">
        <table class="overrides-table">
          <thead>
            <tr>
              <th class="col-code">{{ currentConfig.multiItem ? 'Section' : 'Champ' }}</th>
              <th *ngFor="let lang of contentLangSrcs" class="col-lang">{{ lang.shortCode | uppercase }}</th>
            </tr>
          </thead>
          <tbody>

            <!-- Mode single item : rows = fields ──────────────────────────── -->
            <ng-container *ngIf="!currentConfig.multiItem">
              <tr *ngFor="let field of currentConfig.fields; trackBy: trackByField">
                <td class="col-code col-code-field">
                  <span class="field-label">{{ currentConfig.fieldLabels[field] }}</span>
                  <code class="field-key">{{ field }}</code>
                </td>
                <td *ngFor="let lang of contentLangSrcs" class="col-cell"
                    [class.cell-saving]="contentStates[context.items[0]?.id]?.[lang.shortCode] === 'saving'"
                    [class.cell-saved]="contentStates[context.items[0]?.id]?.[lang.shortCode] === 'saved'"
                    [class.cell-error]="contentStates[context.items[0]?.id]?.[lang.shortCode] === 'error'">
                  <textarea
                    #tc
                    [(ngModel)]="contentData[context.items[0]?.id][lang.shortCode][field]"
                    (input)="autoGrow(tc)"
                    (focus)="autoGrow(tc)"
                    (blur)="onContentBlur(context.items[0]?.id, lang.shortCode, field, tc)"
                    rows="1"
                    class="cell-input"
                    spellcheck="false"></textarea>
                  <span class="cell-indicator" aria-hidden="true"></span>
                </td>
              </tr>
            </ng-container>

            <!-- Mode multi items : rows = items ───────────────────────────── -->
            <ng-container *ngIf="currentConfig.multiItem">
              <tr *ngFor="let item of context.items; trackBy: trackByItemId">
                <td class="col-code col-code-field">
                  <span class="field-label">{{ item.name }}</span>
                  <code class="field-key">{{ item.id }}</code>
                </td>
                <td *ngFor="let lang of contentLangSrcs" class="col-cell"
                    [class.cell-saving]="contentStates[item.id]?.[lang.shortCode] === 'saving'"
                    [class.cell-saved]="contentStates[item.id]?.[lang.shortCode] === 'saved'"
                    [class.cell-error]="contentStates[item.id]?.[lang.shortCode] === 'error'">
                  <textarea
                    #tm
                    [(ngModel)]="contentData[item.id][lang.shortCode][currentConfig.fields[0]]"
                    (input)="autoGrow(tm)"
                    (focus)="autoGrow(tm)"
                    (blur)="onContentBlur(item.id, lang.shortCode, currentConfig.fields[0], tm)"
                    rows="1"
                    class="cell-input"
                    spellcheck="false"></textarea>
                  <span class="cell-indicator" aria-hidden="true"></span>
                </td>
              </tr>
            </ng-container>

          </tbody>
        </table>
      </div>
    </ng-container>

  </div>
</div>
